import styled from 'styled-components'

const Icon = styled.img`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin: ${({ margin }) => margin};
`

export default Icon
